import React from 'react';
import HeroSection from './sections/HeroSection';
import TrustSection from './sections/TrustSection';
import AboutSection from './sections/AboutSection';
import ProjectsSection from './sections/ProjectsSection';
import PlatformSection from './sections/PlatformSection';
import NotesSection from './sections/NotesSection';
import ContactSection from './sections/ContactSection';

const InitialPage = () => {
    return (
        <main>
            <HeroSection />
            <TrustSection />
            <AboutSection />
            <ProjectsSection />
            <PlatformSection />
            <NotesSection />
            <ContactSection />
        </main>
    );
};

export default InitialPage;